<template>
  <div
    class="main-container"
    style="display: flex; flex-direction: column; background-color: #efefef"
  >
    <div class="banner">
      <div class="wrap">
        <div class="top">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="'/course'">课程</el-breadcrumb-item>
            <el-breadcrumb-item>{{ courseData.title }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="bottom">
          <p class="title">{{ courseData.title }}</p>
          <div class="info">
            <span class="intro">{{ courseData.longTitle }}</span>
            <span class="sep">|</span>
            <a
              ><span>
                {{
                  $store.getters["enums/getSysEnumTextByValue"](
                    "CourseLevel",
                    courseData.level
                  )
                }}
                /
                {{
                  $store.getters["enums/getSysEnumTextByValue"](
                    "CourseType",
                    courseData.type
                  )
                }}</span
              ></a
            >
            <span class="i">•</span>
            <span>共32节</span>
            <span class="i">•</span>
            <span>225人已学习</span>
          </div>
          <div class="price">
            <div class="price-text">
              <p class="sale">¥ 免费</p>
            </div>
            <template v-if="roles.includes('Student') &
                    !(roles.includes('Administrator') |
                    roles.includes('Admin'))">
            <a
              v-if="!state"
              class="sale-price l"
              style="cursor: pointer"
              @click="subscribeCourse"
            >
              订阅学习
            </a>
            <a
              v-else
              class="sale-price l"
              style="cursor: pointer"
              @click="unSubscribeCourse"
            >
              取消订阅
            </a>
          </template>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="left_con">
        <div
          class="img"
          :style="{
            'background-image': `url(${fileUrl}/${courseData.mainImage})`,
          }"
        >
          <div class="ebook">
            {{
              $store.getters["enums/getSysEnumTextByValue"](
                "CourseType",
                courseData.type
              )
            }}
          </div>
        </div>
        <div class="left-item">
          <div style="width: 20px">
            <i v-if="actionIndex === 0" class="el-icon-caret-right"></i>
          </div>
          <a @click="actionIndex = 0" :class="actionIndex === 0 ? 'active' : ''"
            >课程介绍</a
          >
        </div>
        <div class="left-item">
          <div style="width: 20px">
            <i v-if="actionIndex === 1" class="el-icon-caret-right"></i>
          </div>
          <a @click="actionIndex = 1" :class="actionIndex === 1 ? 'active' : ''"
            >课程目录</a
          >
        </div>
      </div>

      <div
        class="center_con"
        style="display: flex; flex-flow: column; flex-grow: 1"
      >
        <div v-if="actionIndex === 1" class="chapter">
          <div class="catalog-title">
            课程目录
            <span>已更新32节</span>
          </div>
          <div class="item-box">
            <div
              class="item"
              v-for="catalogData in courseCatalogData"
              :key="catalogData"
            >
              <div class="section">
                <a v-if="catalogData.type" :href="`/read/${catalogData.id}`">
                  <p class="sec_name">{{ catalogData.name }}</p>
                  <div class="taste-btn">阅读</div>
                </a>
                <p v-else class="sec_name">{{ catalogData.name }}</p>
              </div>
              <ul>
                <li v-for="node in catalogData.children" :key="node.id">
                  <a v-if="node.type" :href="`/read/${node.id}`">
                    <div class="articleName">
                      {{ node.name }}
                    </div>
                    <div class="info">
                      <span>{{
                        new Date(node.creationTime) | parseTime("{y}-{m}-{d}")
                      }}</span>
                    </div>
                    <div class="taste-btn">阅读</div>
                  </a>
                  <div v-else class="articleName">
                    {{ node.name }}
                  </div>
                </li>
                <!-- <li>
                  <a>
                    <div class="articleName">02 商城首页商城设置</div>
                    <div class="info">
                      <span>2023-05</span>
                    </div>
                    <div class="lock-btn">
                      <i class="el-icon-lock"></i>
                    </div>
                  </a>
                </li> -->
              </ul>
            </div>
          </div>
        </div>
        <div v-if="actionIndex === 0" class="content">
          <div style="padding-top: 20px" v-html="courseData.intro"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { courseCatalogService, courseService } from "@/api/courses";
import { myCourseService } from "@/api/profiles";
export default {
  name: "Course",
  computed: {
    ...mapGetters("user", ["name", "avatar", "roles"]),
  },
  data() {
    return {
      actionIndex: 1,

      courseData: {
        id: undefined,
        mainImage: undefined, // 主图
        title: "", // 标题
        longTitle: "", // 长标题
        platform: undefined, // 平台
        type: undefined, // 类型
        level: undefined, // 层次
        intro: undefined, // 介绍
      },
      courseCatalogData: [], // 章节

      state: false, // 订阅状态

      fileUrl: process.env.VUE_APP_FILE_URL,
    };
  },
  created() {
    const id = this.$route.params && this.$route.params.id;
    this.getCourse(id);
    this.getCatalog(id);
    this.getMyCourse(id);
  },
  methods: {
    // 获取课程
    getCourse(id) {
      courseService
        .getCourseById(id)
        .then((res) => {
          this.courseData = res;
          //this.imageUrl = `${process.env.VUE_APP_FILE_URL}/${res.mainImage}`
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取目录
    getCatalog(courseId) {
      courseCatalogService.getCourseCatalogTreeList(courseId).then((res) => {
        this.courseCatalogData = res.items;
      });
    },
    // 获取订阅信息
    getMyCourse(id) {
      myCourseService.getByCourseId(id).then((res) => {
        this.state = res.state;
      });
    },
    // 订阅课程
    subscribeCourse() {
      myCourseService
        .subscribeCourse({
          courseId: this.courseData.id,
          title: this.courseData.title,
          longTitle: this.courseData.longTitle,
          mainImage: this.courseData.mainImage,
          state: true,
        })
        .then((res) => {
          this.state = res.state;
        });
    },
    // 取消订阅
    unSubscribeCourse() {
      myCourseService.unSubscribeCourse(this.courseData.id).then((res) => {
        if (res) {
          this.state = false;
        }
      });
    },
  },
};
</script>

<style scoped>
.banner {
  width: 100%;
  height: 244px;
  /* background-color: #383d42; */
  background-color: #5f7d9b;
}

.wrap {
  width: 1152px;
  margin: 0 auto;
  padding-left: 276px;
  padding-top: 24px;
  box-sizing: border-box;
}

.top {
  width: 100%;
  margin-bottom: 8px;
  height: 24px;
}

.top ::v-deep span {
  line-height: 24px;
  font-size: 12px;
  font-weight: 400 !important;
  color: rgba(255, 255, 255, 0.6) !important;
}

.title {
  font-size: 24px;
  color: #fff;
  line-height: 24px;
  text-align: left;
  margin-bottom: 16px;
}

.bottom .info {
  font-size: 0;
  margin-bottom: 16px;
}

.info .intro {
  font-size: 16px;
  color: #fff;
  text-align: left;
  line-height: 16px;
  display: inline-block;
  max-width: 402px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: bottom;
}

.info span {
  display: inline-block;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  text-align: left;
  line-height: 16px;
}

.sep {
  color: rgba(255, 255, 255, 0.2);
  margin: 0 24px;
}

.i {
  padding: 0 4px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  text-align: left;
  line-height: 16px;
}

.price {
}

.price-text {
  margin-bottom: 8px;
}

.sale {
  font-size: 24px;
  color: #fff;
  text-align: left;
  line-height: 32px;
  margin-right: 16px;
}

.sale-price {
  padding: 8px 24px;
  background: #37f;
  border-radius: 24px;
  color: #fff;
  font-size: 16px;
}

.l {
  float: left;
}

.container {
  width: 1152px;
  margin: 0 auto;
  margin-bottom: 36px;

  display: flex;
}

.left_con {
  width: 244px;
  position: relative;
  top: -200px;
  left: 0;
  margin-right: 32px;
}

.left_con .img {
  width: 244px;
  height: 162px;
  margin: 0 auto;
  position: relative;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  box-shadow: 0 4px 7px 0 rgba(28, 31, 33, 0.06),
    0 7px 14px 0 rgba(28, 31, 33, 0.06), 0 11px 21px 0 rgba(28, 31, 33, 0.06),
    0 14px 28px 0 rgba(28, 31, 33, 0.06);
  border-radius: 10.67px;
  margin-bottom: 50px;
  transition: all 0.3s;
  -moz-transition: all 0.3s;
  -webkit-transition: all 0.3s;
  -o-transition: all 0.3s;
}

.left-item {
  width: 100%;
  height: 54px;
  line-height: 54px;
  font-size: 0;

  display: flex;
}

.left-item i {
  font-size: 20px;
  color: #37f;
  text-align: left;
  line-height: 54px;
}

.left-item a {
  display: inline-block;
  width: 120px;
  font-size: 16px;
  color: #1c1f21;
  text-align: left;
  line-height: 54px;
  border-bottom: 1px solid rgba(28, 31, 33, 0.1);
  vertical-align: top;

  cursor: pointer;
}

.left-item a.active {
  color: #37f;
  font-weight: 700;
  border-bottom: 1px solid #37f;
}

.left_con .img .ebook {
  position: absolute;
  bottom: 5px;
  left: 6px;
  background: rgba(0, 0, 0, 0.5);
  box-shadow: 0 2px 4px 0 rgba(28, 31, 33, 0.2);
  border-radius: 13px;
  font-size: 12px;
  color: #fff;
  text-align: center;
  line-height: 12px;
  padding: 6px 8px;
}

.center_con {
  /* width: 680px; */
  /* width: 876px; */
  margin-top: -24px;
  position: relative;
}

/* 内容 */
.center_con .content {
  background: #fff;
  padding: 0 32px 32px;
  box-sizing: border-box;

}

.center_con .content ::v-deep p
{
  margin: revert !important;
  padding: revert !important;
}

/* 章节 */
.center_con .chapter {
  background: #fff;
  padding: 16px 32px;
  box-sizing: border-box;
  position: relative;
}

.catalog-title {
  font-size: 18px;
  color: #1c1f21;
  line-height: 18px;
  border-bottom: 1px solid rgba(28, 31, 33, 0.1);
  padding: 16px 0;
  font-weight: 700;
  margin-bottom: 16px;
}

.catalog-title span {
  font-size: 12px;
  color: #9199a1;
  text-align: left;
  line-height: 18px;
  margin-left: 16px;
  font-weight: 400;
}

.item-box {
}

.item {
}

.item .section {
  width: 100%;
  border-bottom: 1px solid rgba(28, 31, 33, 0.1);
}

.section {
  position: relative;
}

.section .taste-btn {
  width: 76px;
  height: 36px;
  position: absolute;
  top: 8px;
  right: 0;
  text-align: center;
  font-size: 14px;
  color: #37f;
  line-height: 36px;
  font-weight: 700;
  background: rgba(51, 119, 255, 0.1);
  border-radius: 18px;
  transition: all 0.3s;
  -moz-transition: all 0.3s;
  -webkit-transition: all 0.3s;
  -o-transition: all 0.3s;
}

.sec_name {
  width: 100%;
  font-size: 15px;
  color: #1c1f21;
  line-height: 18px;
  text-align: left;
  font-weight: 700;
  padding: 16px 0;
}

ol,
ul {
  list-style: none;
}

.item ul li {
  position: relative;
  box-sizing: border-box;
  padding: 16px 0;
  border-bottom: 1px solid rgba(28, 31, 33, 0.1);
}

.item ul li .articleName {
  max-width: 380px;
  font-size: 15px;
  color: #1c1f21;
  line-height: 24px;
  margin-bottom: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.item ul li .info span {
  font-size: 14px;
  color: #9199a1;
  line-height: 14px;
}

.item ul li .taste-btn {
  width: 76px;
  height: 36px;
  position: absolute;
  top: 16px;
  right: 0;
  text-align: center;
  font-size: 14px;
  color: #37f;
  line-height: 36px;
  font-weight: 700;
  background: rgba(51, 119, 255, 0.1);
  border-radius: 18px;
  transition: all 0.3s;
  -moz-transition: all 0.3s;
  -webkit-transition: all 0.3s;
  -o-transition: all 0.3s;
}

.item ul li .lock-btn {
  position: absolute;
  top: 16px;
  right: 30px;
  font-size: 16px;
  color: #9199a1;
  line-height: 24px;
  cursor: pointer;
}
</style>
